import React from 'react';
import movements from '../../../../../../services/movements';
import MovementTableItem from '../movement-table-item/index';

export default class MovementsTable extends React.Component {
    state = {
        pick: true,
        invalid: false,
        total: -1
    }

    componentWillReceiveProps(nextProps) {
        if(!nextProps.start || !nextProps.end)
            this.setState({
                pick: true,
                invalid: false
            })
        if(nextProps.start && nextProps.end) {
            if(nextProps.start.getTime() > nextProps.end.getTime())
                this.setState({
                    pick: false,
                    invalid: true
                })
            else {
                let start = nextProps.start.getTime()
                let end = nextProps.end.getTime()
                movements.find({date: {$lte: end, $gte: start}})
                    .sort({date: -1}).exec((err, elem) => {
                    let total = 0;
                    elem.forEach((movement) => {
                        total+=movement.pay
                    })

                    this.setState({
                        movements: elem,
                        invalid: false,
                        pick: false,
                        total: total
                    });
                });
            }
        }
    }

    componentWillMount() {
        this.componentWillReceiveProps(this.props)
    }

    render() {
        if(this.state.pick)
            return <p>Seleccione un rango de fechas</p>

        if(this.state.invalid)
            return <p>Rango de fechas inválido</p>

        return (
            <table className="table is-fullwidth">
                <thead>
                    <tr>
                        <td>
                            <p><b>Total: </b>${this.state.total}</p>
                        </td>
                    </tr>
                    <tr>
                        <th>Cantidad</th>
                        <th>Cliente</th>
                        <th>Fecha</th>
                        <th>Recibió</th>
                    </tr>
                </thead>
                <tbody>
                    {this.state.movements.map((movement, index) => (
                        <MovementTableItem key={index} movement={movement} />
                    ))}
                </tbody>
            </table>
        );
    }
}


// WEBPACK FOOTER //
// ./src/scenes/main-page/scenes/movements/components/movements-table/index.js